export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = [DEFAULT_PAGE_SIZE, 100, 250];
